import React, { useEffect, useState } from "react"

// Services
import ticketServices from "src/services/tickets"
import DesktopLoading from "../../../common/desktop-loading"
import Error from "../../../common/error"
import DesktopWrapper from "../../../layout/desktop/desktop-wrapper"
import { toast } from "react-toastify"
import TicketCreateForm from "../components/ticket-create-from"

// Mui
import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material"
import MainCard from "../../../common/main-card"
import TicketInfo from "../components/ticket-info"
import TablePagination from "src/components/common/table-pagination"
import Head from "next/head"

// -------------------------------------------|| DESKTOP TICKETS - PAGE COMPONENTS || ---------------------------------

const DesktopTickets = () => {
  const theme = useTheme()

  const [state, setState] = useState("loading" | "error" | "done")
  const [data, setData] = useState([])
  const [selectedTicket, setSelectedTicket] = useState()
  const [controller, setController] = useState({
    total: 0,
    pageIndex: 0,
    pageSize: 9
  })
  const [dialog, setDialog] = useState({
    create: false,
    info: false
  })

  const onPageSelect = pageNo =>
    setController(perv => ({
      ...perv,
      pageIndex: pageNo
    }))

  const getTicketList = () => {
    setState("loading")
    const filterData = {
      PageIndex: controller?.pageIndex + 1,
      PageSize: controller?.pageSize
    }

    ticketServices?.getTicketList(filterData).then(response => {
      if (response?.status === 200) {
        if (!response?.data?.succeed) {
          setState("error")
          toast.error(response?.data?.message)
        } else {
          setController(perv => ({
            ...perv,
            total: response?.data?.value?.total
          }))
          setData(response?.data?.value?.list)
          setState("done")
        }
      }
    })
  }

  useEffect(() => {
    getTicketList()
  }, [controller?.pageIndex])

  const renderTickets = () => {
    if (state === "loading") {
      return <DesktopLoading />
    }
    if (state === "error") {
      return <Error desktopCentred={true} />
    }
    if (state === "done") {
      return (
        <>
          <Head>
            <title>ثبت درخواست پشتیبانی</title>
          </Head>
          <Box display={"flex"} justifyContent={"center"}>
            <Box mt={5} width={"94%"}>
              <DesktopWrapper title='ثبت درخواست پشتیبانی'>
                <Stack direction='row' justifyContent='space-between' alignItems='center' py={2}>
                  <div></div>

                  <Button
                    size='large'
                    variant='contained'
                    sx={{ borderRadius: "8px" }}
                    onClick={() => setDialog(perv => ({ ...perv, create: true }))}
                  >
                    ثبت درخواست پشتیبانی
                  </Button>
                </Stack>

                <Grid container spacing={1.5} sx={{ m: 2 }}>
                  {data?.map((item, index) => (
                    <Grid key={index} item xs={10} md={4} pb={2}>
                      <MainCard
                        onClick={() => {
                          setDialog(perv => ({ ...perv, info: true }))
                          setSelectedTicket(item)
                        }}
                        sx={{
                          borderRadius: "12px",
                          py: 4,
                          boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                          cursor: "pointer"
                        }}
                      >
                        <Stack spacing={0.5}>
                          <Typography
                            variant='h5'
                            fontWeight={500}
                            textAlign='center'
                            color={theme.palette?.mode === "light" ? "#000000" : "#fff"}
                          >
                            {item?.type}
                          </Typography>
                          <Typography textAlign='center' color='secondary'>
                            {item?.status}
                          </Typography>
                          <Typography textAlign='center'>{item?.trackingCode}</Typography>
                        </Stack>
                      </MainCard>
                    </Grid>
                  ))}
                </Grid>
                {/* <Box sx={{ p: 2, py: 3, mt: 3 }}>
                <TablePagination
                  total={controller?.total}
                  selectPage={onPageSelect}
                  pageIndex={controller?.pageIndex}
                  pageSize={controller?.pageSize}
                />
              </Box> */}
              </DesktopWrapper>
            </Box>
          </Box>
          <TicketCreateForm open={dialog.create} setOpen={setDialog} list={getTicketList} />
          <TicketInfo open={dialog?.info} setOpen={setDialog} ticket={selectedTicket} />
        </>
      )
    }
  }

  return <>{renderTickets()}</>
}

export default DesktopTickets
